'use strict';
// import './style.css';

export class PopupForm
{
    constructor(options = [])
    {
        this.options = options;
        this.init();
    }

    init()
    {
        const instance = this

        document.getElementById('ajax-form-support').addEventListener("submit", function (e) {
            instance.sendForm(e)
        })
    }

    sendForm(e) {
        e.preventDefault()
        let url = e.target.getAttribute('action')
        let formData = new FormData(e.target)

        fetch(url, {
            method: 'POST',
            body: formData
        }).then(
            function (response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                        response.status);
                    return;
                }
                e.target.reset()
                $.fancybox.open({src:'/local/templates/land/ajax/popups/msg.php',type:'ajax',touch: false,closeExisting: true,autoFocus: false})
            }
        ).catch(function (err) {
            console.log('Fetch Error :-S', err);
        });
    }
}